import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { RouterModule } from "@angular/router";

import { Category, NotificationType } from "../../../apis/networkdashboard/graphql/graphql";

@Component({
  selector: "service-status",
  templateUrl: "service-status.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, DatePipe, RouterModule, TranslatePipe],
})
export class ServiceStatusComponent {
  protected subscriptionId = input.required<string>();
  protected productType = input.required<string>();
  protected serviceDisruption = input.required<NotificationType>();

  protected startTimestamp = computed(() => this.serviceDisruption().startDate);
  protected endTimestamp = computed(() => this.serviceDisruption().endDate);
  protected category = computed(() => this.serviceDisruption().category);
  protected heading = computed(() => this.serviceDisruption().heading);

  protected isNowActive = computed(() => this.startTimestamp() && Date.now() > this.startTimestamp());

  protected getRouterLink = computed(() => `/storing-en-onderhoud/${this.productType()}/${this.subscriptionId()}`);

  protected notificationIcon = computed(() => this.getNotificationIcon(this.category(), this.isNowActive()));
  protected notificationColor = computed(() => this.getNotificationColor(this.category()));
  protected impactType = computed(() => mapImpactCodeToTranslationString(this.serviceDisruption().impact));

  private getNotificationIcon(category: Category, isNowActive: boolean): string {
    switch (category) {
      case Category.Malfunction:
        return "status-malfunction";
      case Category.Plannedwork:
        return isNowActive ? "status-maintenance" : "status-maintenance-planned";
      case Category.General:
        return "status-maintenance";
    }
  }

  private getNotificationColor(category: Category): string {
    switch (category) {
      case Category.Malfunction:
        return "red";
      case Category.Plannedwork:
        return "blue";
      case Category.General:
        return "blue";
    }
  }
}

function mapImpactCodeToTranslationString(impact: string): string {
  switch (impact.toLocaleLowerCase()) {
    case "reduced_redundancy":
      return "Malfunction.Impact.ReducedRedundancy";
    case "resilience_loss":
      return "Malfunction.Impact.ResilienceLoss";
    case "down":
      return "Malfunction.Impact.DownTime";
    default:
      return "Malfunction.Impact.NoImpact";
  }
}
